import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';
import { isEmpty } from 'ramda';

const SqueezeAnimation = ({ json, isPlaying }) => {
  const animationRef = useRef();
  const animation = animationRef.current || {};

  useEffect(() => {
    if (!isEmpty(animation)) {
      if (isPlaying) {
        animation.play();
      } else {
        animation.pause();
      }
    }
  }, [isPlaying]);

  if (!json) return null;

  return (
    <Lottie
      lottieRef={animationRef}
      animationData={json}
      style={{ width: '100%', height: '100%' }}
      rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
    />
  );
};

SqueezeAnimation.propTypes = {
  json: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool.isRequired,
};

export default SqueezeAnimation;
